import { createFileRoute, Navigate } from "@tanstack/react-router";

export const Route = createFileRoute("/_public/track/order/$code")({
  component: TrackOrderRedirect,
});

function TrackOrderRedirect() {
  const { code } = Route.useParams();
  return <Navigate to="/track/$code" params={{ code }} replace />;
}
